import './Services.css'

const IcoCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
)
const IcoArrow = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
)

const SERVICES = [
  {
    num: '01',
    tag: 'Transport',
    title: 'Formulaire de réservation de transport',
    body: "Effectuez une demande de transport en quelques minutes. Renseignez l'animal, le lieu de départ, la destination et la date souhaitée. Notre équipe vous contacte pour confirmer.",
    btnLabel: 'Réserver un transport',
    btnAction: 'contact',
  },
  {
    num: '02',
    tag: 'Administratif',
    title: 'Gestion des formalités administratives',
    body: "Nous prenons en charge la préparation et le suivi de tous les documents requis : passeport, carnet de santé, certificat vétérinaire, documents douaniers et autorisations d'import/export.",
    btnLabel: 'En savoir plus',
    btnAction: 'admin-formalites',
  },
  {
    num: '03',
    tag: 'Facturation',
    title: 'Facturation sécurisée et transparente',
    body: "Retrouvez toutes vos factures depuis votre espace client. Chaque prestation donne lieu à une facture détaillée que vous pouvez consulter, télécharger ou imprimer à tout moment.",
    btnLabel: 'Accéder à mon espace',
    btnAction: 'profile',
  },
  {
    num: '04',
    tag: 'Suivi',
    title: 'Suivi en temps réel du transport',
    body: "Suivez l'avancement du transport à chaque étape : réservation, documents validés, prise en charge, transit, arrivée et livraison. Notifications e-mail ou SMS incluses.",
    btnLabel: 'Suivre mon transport',
    btnAction: 'tracking',
  },
]

export default function Services({ onContactClick, onProfileClick, onTrackingClick, onAdminFormalites, isLoggedIn, isActive = true, onAuthClick }) {
  const handleBtn = (action) => {
    if (action === 'admin-formalites') {
      if (onAdminFormalites) onAdminFormalites()
    } else if (action === 'contact') {
      if (onContactClick) onContactClick()
      else document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
    } else if (action === 'profile') {
      if (!isLoggedIn) {
        if (onAuthClick) onAuthClick()
      } else if (!isActive) {
        window.alert('Votre compte est banni. Vous ne pouvez pas accéder à cet espace.')
      } else {
        if (onProfileClick) onProfileClick()
      }
    } else if (action === 'tracking') {
      if (!isLoggedIn) {
        if (onAuthClick) onAuthClick()
      } else if (!isActive) {
        window.alert('Votre compte est banni. Vous ne pouvez pas accéder au suivi.')
      } else {
        if (onTrackingClick) onTrackingClick()
        else document.getElementById('tracking-service')?.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <section className="sv-section">
      <div className="sv-inner">

        {/* ── En-tête pleine largeur : texte à gauche, stats+trust à droite ── */}
        <div className="sv-header">
          <div className="sv-header-left">
            <div className="sv-eyebrow">
              <span className="sv-eyebrow-line" />
              NOS SERVICES
            </div>
            <h2 className="sv-title">
              Tout ce dont vous avez besoin<br />
              pour <span className="sv-title-accent">adopter sereinement</span>
            </h2>
            <p className="sv-desc">
              De la réservation du transport à la livraison finale, nous accompagnons
              chaque étape de l'adoption de votre animal avec professionnalisme et transparence.
            </p>
          </div>

          <div className="sv-header-right">
            <div className="sv-stats">
              {[
                { val: '5',    label: 'Services inclus'   },
                { val: '24h',  label: 'Délai de réponse'  },
                { val: '100%', label: 'Sécurisé'          },
              ].map(({ val, label }) => (
                <div className="sv-stat" key={label}>
                  <div className="sv-stat-val">{val}</div>
                  <div className="sv-stat-label">{label}</div>
                </div>
              ))}
            </div>

            <div className="sv-trust">
              {[
                'Transport conforme aux réglementations',
                'Documents vérifiés avant le départ',
                'Suivi en temps réel à chaque étape',
              ].map(t => (
                <div className="sv-trust-item" key={t}>
                  <span className="sv-trust-icon"><IcoCheck /></span>
                  {t}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Grille de cartes en dessous ── */}
        <div className="sv-grid">
          {SERVICES.map((svc) => (
            <div key={svc.num} className="sv-card">
              <div className="sv-card-head">
                <span className="sv-card-num">{svc.num}</span>
                <span className="sv-card-tag">{svc.tag}</span>
              </div>
              <h3 className="sv-card-title">{svc.title}</h3>
              <p className="sv-card-body">{svc.body}</p>
              <button className="sv-card-btn" onClick={() => handleBtn(svc.btnAction)}>
                {svc.btnLabel} <IcoArrow />
              </button>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}